module.exports = __webpack_public_path__ + "img/ic_x_grey.cb4d497b.svg";